import React from "react"
import News from "../../../blocks/en/news_page"
import { Link, graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "krapukhin_transfers_to_riga" }) {
    ...NewsInfoEn
  }
}`

export default class NewsTextEn extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Russian forward Stanislav Krapukhin of FC Zenit St. Petersburg has signed a contract with Latvian champion FC Riga.</p>
        </div>
      </div>
    )
  }
}